import React from 'react'
import { css, keyframes } from 'emotion'
import { View } from 'oio-react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import GroupHome from '~/apps/Home'
import GroupView from '~/apps/View'

const animateIn = keyframes`
   0% {
      opacity: 0;
      transform: translate3d(0, 5%, 0);
   }

   100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
   }
`

const Groups = () => {
   const match = useRouteMatch()

   return (
      <View
         className={css`
            opacity: 1;
            animation: ${animateIn} 700ms ease both;
         `}
         minHeight="100vh"
         width="100%">
         <Switch>
            <Route exact path={match.path} component={GroupHome} />
            <Route path={`${match.path}/:initiativeSlug`} component={GroupView} />
         </Switch>
      </View>
   )
}

export default Groups
